import { z } from 'zod';
import { Millimeters } from './primitives.js';
import { Layer } from './layers.js';

/** Version de esquema vigente. Subirla EXIGE migrador + golden test. */
export const CURRENT_SCHEMA_VERSION = 3 as const;

/**
 * P1 — El documento canonico es la verdad. El lienzo es una vista de el, nunca
 * al reves. Se guarda en JSONB, validado por Zod, versionado y migrable.
 */
export const CanonicalDocument = z.object({
  schemaVersion: z.literal(CURRENT_SCHEMA_VERSION),
  /**
   * Origen y ejes DECLARADOS. Sin esto, "x: 30" no significa nada: no se sabe
   * desde donde ni hacia donde crece.
   */
  origin: z.object({
    zoneId: z.string().min(1),
    axis: z.enum(['y-down', 'y-up']).default('y-down'),
  }),
  /** Tamano de la zona de marcaje sobre la que se disena, en mm. */
  canvasMm: z.object({
    width: Millimeters.refine((v) => v > 0, 'width debe ser > 0'),
    height: Millimeters.refine((v) => v > 0, 'height debe ser > 0'),
  }),
  layers: z.array(Layer),
});
export type CanonicalDocument = z.infer<typeof CanonicalDocument>;

/** Documento vacio valido para una zona dada. Punto de partida del editor. */
export function emptyDocument(zoneId: string, widthMm: number, heightMm: number): CanonicalDocument {
  return {
    schemaVersion: CURRENT_SCHEMA_VERSION,
    origin: { zoneId, axis: 'y-down' },
    canvasMm: { width: widthMm, height: heightMm },
    layers: [],
  };
}
